import React, { setGlobal } from "reactn";
import PropTypes from "prop-types";

// Hooks
import appHook from "../../../../hooks/appHook";

// helpers
import { allowOnlyNumbers } from "../../../../helpers/Helpers";

import FormGroup from "../../../_common/form/form_group/FormGroup";
import InputGroup from "../../../_common/form/input_group/InputGroup";
import Label from "../../../_common/form/label/Label";
import Input from "../../../_common/form/input/Input";
import Error from "../../../_common/error/Error";

import validate from "../../../_steps/userDetails/userDetailsRules";

const NumberInputManual = props => {
    const { numberValue, values, min, handleSubmit } = props;

    const setTopUpValue = topup => {
        // Set value of input to number and set to global value
        values[numberValue] = parseInt(topup.target.value, 10);
        setGlobal({
            values: values
        });
    };

    const { handleKeyup, handleFocus, handleBlur, focus, errors } = appHook(validate, handleSubmit);

    return (
        <FormGroup focused={focus === "value" ? true : !!(false || values.topUpValue)} error={errors.topUpValue}>
            <InputGroup error={errors.topUpValue}>
                <Label htmlFor="value" text="value (min. €40)" icon />
                <Input
                    id="value"
                    type="number"
                    name={numberValue}
                    change={setTopUpValue}
                    keyup={handleKeyup}
                    keypress={allowOnlyNumbers}
                    focus={handleFocus}
                    blur={handleBlur}
                    value={values[numberValue] || ""}
                    icon
                    symbol="&euro;"
                    min={min}
                />
            </InputGroup>
            {errors.topUpValue && <Error error={errors.topUpValue} />}
        </FormGroup>
    );
};

// props validation
NumberInputManual.propTypes = {
    numberValue: PropTypes.string,
    values: PropTypes.object,
    min: PropTypes.number
};

export default NumberInputManual;
